import React, { useEffect, useRef, useState } from 'react';
import { ContainerRow } from '../styledComponents';
import { PrintButton } from '../Audit/styledComponents';
import SessionDetails from './SessionDetails';
import { PrinterOutlined } from '@ant-design/icons';
import Spinner from '../../CustomComponents/Spinner';
import { useSelector } from 'react-redux';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import moment from 'moment';
import { DATE_TIME_FORMAT } from '../../../Constants/StringConstants';
import { notification } from 'antd';
import { findPatientMoreDetails } from '../../../Apis/Doctor';
import {
  billJob,
  getJobInfoForPrint,
  getDemographics,
  sectionFetch
} from '../../../Apis/Jobs';
import {
  getDataOfPatient,
  getCoverages,
  getContacts,
  getAllergyIntoleranceData,
  getAdvanceDirectivesConsentsData,
  getPractitionersData
} from '../../../Apis/Patient';

const FaceSheet = () => {
  const { jobId } = useParams();
  const user = useSelector(state => state.userReducer);
  const location = useLocation();
  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [loadings, setLoadings] = useState(true);
  const [printInfoData, setPrintInfoData] = useState([]);
  const [printMoreData, setPrintmoreData] = useState([]);
  const [patietSection, setPatietSection] = useState([]);
  const [coverages, setCoverages] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [allergies, setAllergies] = useState([]);
  const [advanceConsents, setAdvanceConsents] = useState([]);
  const [practitioners, setPractitioners] = useState([]);
  const [jobName, setJobName] = useState('');
  const [editorLoading, setEditorLoading] = useState(true);
  const [demographicsLoading, setDemographicsLoading] = useState(false);

  const componentRef = useRef();

  // 🖨️ Print handler
  const handlePrint = useReactToPrint({
    content: () => componentRef.current
  });

  // 📥 Fetch printable job info
  useEffect(() => {
    getJobInfoForPrint(jobId)
      .then(response => {
        if (response.data.success) {
          setPrintInfoData(response.data.result);
          setLoadings(false);
        } else {
          notification.error({
            message: 'Fetch Failed',
            description: response.data.message
          });
        }
      })
      .catch(err => console.log(err));
  }, [jobId]);

  // 📥 Fetch patient details once we have printInfoData
  useEffect(() => {
    if (printInfoData[0]) {
      const facilityId = printInfoData[0]?.facility?.facilityId;
      const patientId = printInfoData[0]?.patientId;
      if (!facilityId || !patientId) return;

      findPatientMoreDetails(facilityId, patientId)
        .then(response => {
          if (response.data.success) {
            setPrintmoreData(response.data.result);
          } else {
            notification.error({
              message: 'Demographics Fetch Failed',
              description: response.data.message
            });
          }
        })
        .catch(err => console.log(err));

      // Fetch DATE OF VISIT from demographics first, then fetch all patient-related sections
      getDemographics(jobId)
        .then(demRes => {
          const visitDateItem = demRes.data?.result?.find(
            item => item.key === 'DATE OF VISIT'
          );
          return visitDateItem?.value ?? null;
        })
        .catch(() => null)
        .then(effectiveDateTime =>
          Promise.all([
            getDataOfPatient(facilityId, patientId),
            getCoverages(facilityId, patientId, effectiveDateTime),
            getContacts(facilityId, patientId),
            getAllergyIntoleranceData(facilityId, patientId),
            getAdvanceDirectivesConsentsData(facilityId, patientId),
            getPractitionersData(facilityId, patientId)
          ])
        )
        .then(
          ([
            patientRes,
            coveragesRes,
            contactsRes,
            allergyRes,
            advanceRes,
            practitionerRes
          ]) => {
            if (patientRes?.data?.success)
              setPatietSection(patientRes.data.result);
            if (coveragesRes?.data?.success)
              setCoverages(coveragesRes.data.result);
            if (contactsRes?.data?.success)
              setContacts(contactsRes.data.result);
            if (allergyRes?.data?.success) setAllergies(allergyRes.data.result);
            if (advanceRes?.data?.success)
              setAdvanceConsents(advanceRes.data.result);
            if (practitionerRes?.data?.success)
              setPractitioners(practitionerRes.data.result);
          }
        )
        .catch(err => console.error('API error:', err))
        .finally(() => setLoadings(false));
    }
  }, [printInfoData]);

  // 📥 Fetch section/editor data
  useEffect(() => {
    sectionFetch(jobId)
      .then(response => {
        if (response.data.success) {
          setJobName(response.data.jobName);
          setEditorLoading(false);
        } else {
          notification.error({
            message: 'Section Fetch Failed',
            description: response.data.message
          });
          setEditorLoading(false);
        }
      })
      .catch(err => {
        console.log(err);
        setEditorLoading(false);
      });
  }, [jobId]);

  return loading && (editorLoading || demographicsLoading) ? (
    <Spinner />
  ) : (
    <>
      <SessionDetails
        printInfoData={printInfoData}
        printMoreData={printMoreData?.medDiagonsis}
        patietSection={patietSection}
        coverages={coverages}
        contacts={contacts}
        allergies={allergies}
        advanceConsents={advanceConsents}
        practitioners={practitioners}
        loading={loadings}
        jobName={jobName}
        ref={componentRef}
      />

      <div style={{ marginTop: 16 }}>
        <PrintButton icon={<PrinterOutlined />} onClick={handlePrint}>
          Print
        </PrintButton>
      </div>
    </>
  );
};

export default FaceSheet;

// import React, { useEffect, useRef, useState } from 'react';
// import { ContainerRow, TitleRow, DividerStyle } from '../styledComponents';

// import { billJob, getJobInfoForPrint } from '../../../Apis/Jobs';
// import { ControlsDiV } from '../styledComponents';
// import { PrintButton } from '../Audit/styledComponents';
// import SessionDetails from './SessionDetails';
// import { PrinterOutlined } from '@ant-design/icons';
// import CustomSideDrawer from '../../CustomComponents/CustomSideDrawer';
// import { AddButton } from './styledComponents';

// import { ContentRow } from '../Editor/styledComponents';
// import { useSelector } from 'react-redux';
// import { Col, Dropdown, notification } from 'antd';
// import { useParams } from 'react-router-dom';
// import { getDemographics, sectionFetch } from '../../../Apis/Jobs';
// import { findPatientMoreDetails } from '../../../Apis/Doctor';
// import { useReactToPrint } from 'react-to-print';
// import PageTitle from '../../../Utils/PageTitle';
// import CustomTypography from '../../CustomComponents/CustomTypography';

// import Demographics from '../Editor/Demographics';
// import Spinner from '../../CustomComponents/Spinner';

// import { useHistory, useLocation } from 'react-router-dom';
// import BreadCrumbComponent from '../../CustomComponents/BreadCrumbComponent';
// import moment from 'moment';
// import { DATE_TIME_FORMAT } from '../../../Constants/StringConstants';
// import NewBillerEditorComponent from '../../CustomComponents/NewBillerEditorComponent';
// import {
//   getDataOfPatient,
//   getCoverages,
//   getContacts,
//   getAllergyIntoleranceData,
//   getAdvanceDirectivesConsentsData,
//   getPractitionersData
// } from '../../../Apis/Patient';
// import MoreHorizIcon from '../../../Assets/Icons/MoreHorizIcon';

// const FaceSheet = props => {
//   const [theme] = useSelector(state => [state.themeReducer]);
//   const { jobId } = useParams();
//   // const { sessionId } = useParams('sessionId');
//   const user = useSelector(state => state.userReducer);
//   const audioRef = useRef();
//   const [readOnly, setReadOnly] = useState(false);
//   const [demographicsData, setDemographicsData] = useState([]);
//   const [localDemographicsData, setLocalDemographicsData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [loadings, setLoadings] = useState(true);
//   const [sections, setSections] = useState(null);
//   const [headings, setHeadings] = useState(null);
//   const [template, setTemplate] = useState('');
//   const [inferenceActive, setInferenceActive] = useState(false);
//   const [drawerVisible, setDrawerVisible] = useState(false);
//   const [demographicsLoading, setDemographicsLoading] = useState(false);
//   const [activeSection, setActiveSection] = useState(null);
//   const [activeSectionContent, setActiveSectionContent] = useState('');
//   const [inferenceData, setInferenceData] = useState([]);
//   const [inferenceAnnotation, setInferenceAnnotation] = useState([]);
//   const [saveStatus, setSaveStatus] = useState(null);
//   const [changeStatus, setChangeStatus] = useState(false);

//   const [jobName, setJobName] = useState('');
//   const [editorLoading, setEditorLoading] = useState(true);
//   const [lastUpdateTime, setLastUpdateTime] = useState(null);
//   const [printInfoData, setPrintInfoData] = useState([]);
//   const [printMoreData, setPrintmoreData] = useState([]);
//   const [patietSection, setPatietSection] = useState([]);
//   const [updateInferenceLoading, setUpdateInferenceLoading] = useState(false);
//   const [editorDataPreviewValue] = useState([]);

//   const location = useLocation();
//   const [userType, setUserType] = useState('');
//   const componentRef = useRef();
//   const [localSectionIdMap] = useState(new Map());
//   const [newInferenceActive, setNewInferenceActive] = useState(false);
//   const [coverages, setCoverages] = useState([]);
//   const [contacts, setContacts] = useState([]);
//   const [allergies, setAllergies] = useState([]);
//   const [advanceConsents, setAdvanceConsents] = useState([]);
//   const [practitioners, setPractitioners] = useState([]);

//   const [jobStage, setJobStage] = useState('');
//   const [refetchDemographics, setRefetchDemographics] = useState(false);
//   const history = useHistory();

//   const [dataMap, setDataMap] = useState({});
//   useEffect(() => {
//     getEditorData();

//     // eslint-disable-next-line
//   }, []);
//   useEffect(() => {
//     getDemographicsData();
//   }, [localDemographicsData]);
//   const handleBillJob = async () => {
//     // history.pushState();
//     setLoading(true); // Set loading to true while the API call is in progress
//     try {
//       const response = await billJob(jobId, user.sessionId);
//       if (response.data.success === true) {
//         notification.success({
//           message: 'Success',
//           description: response.data.message
//         });
//         setLoading(false);
//         history.push('/dashboard/biller');
//       } else {
//         notification.error({
//           message: 'error',
//           description: response.data.message
//         });
//         setLoading(false);
//       }
//     } catch (error) {
//       console.error('Error:', error);
//     } finally {
//       setLoading(false);
//     }
//   };
//   let BreadCrumbItems = [
//     {
//       name: 'Jobs',
//       path: '/dashboard/biller'
//     },

//     {
//       name: `${jobName}`
//     }
//   ];

//   const handlePrint = useReactToPrint({
//     content: () => {
//       return componentRef.current;
//     }
//   });
//   const getDemographicsData = () => {
//     setDemographicsData(localDemographicsData);
//   };
//   useEffect(() => {}, [printMoreData]);
//   useEffect(() => {
//     getJobInfoForPrint(jobId)
//       .then(response => {
//         if (response.data.success === true) {
//           setPrintInfoData(response.data.result);
//           setLoadings(false);
//         } else {
//           notification['error']({
//             message: ' Fetch Failed',
//             description: response.data.message
//           });
//         }
//         // setDemographicsLoading(false);
//         // setRefetchDemographics(false);
//       })
//       .catch(err => {
//         // setDemographicsLoading(false);
//         // setRefetchDemographics(false);
//         console.log(err);
//         // setDemographicsLoading(false);
//       });
//   }, []);
//   useEffect(() => {
//     if (printInfoData[0]) {
//       findPatientMoreDetails(
//         printInfoData[0]?.facility.facilityId,
//         printInfoData[0]?.patientId
//       )
//         .then(response => {
//           if (response.data.success === true) {
//             setPrintmoreData(response.data.result);
//             // setLoadings(false);
//           } else {
//             notification['error']({
//               message: 'Demographics Fetch Failed',
//               description: response.data.message
//             });
//           }
//           // setDemographicsLoading(false);
//           // setRefetchDemographics(false);
//         })
//         .catch(err => {
//           // setDemographicsLoading(false);
//           // setRefetchDemographics(false);
//           console.log(err);
//           // setDemographicsLoading(false);
//         });
//     }
//   }, [printInfoData]);
//   useEffect(() => {
//     const searchParams = new URLSearchParams(location.search);
//     setUserType(searchParams.get('userType'));
//     setJobStage(searchParams.get('jobStage'));

//     setDemographicsLoading(true);
//     getDemographics(jobId)
//       .then(response => {
//         if (response.data.success === true) {
//           setLocalDemographicsData(response.data.result);
//           setDemographicsLoading(false);
//         } else {
//           notification['error']({
//             message: 'Demographics Fetch Failed',
//             description: response.data.message
//           });
//           setDemographicsLoading(false);
//         }
//         setRefetchDemographics(false);
//       })
//       .catch(err => {
//         console.log(err);
//         setDemographicsLoading(false);
//       });

//     // eslint-disable-next-line
//   }, [refetchDemographics]);

//   useEffect(() => {
//     if (printInfoData?.[0]) {
//       const facilityId = printInfoData?.[0]?.facility?.facilityId;
//       const patientId = printInfoData?.[0]?.patientId;
//       if (!facilityId || !patientId) return;

//       setLoadings(true); // Start loading earlier

//       Promise.all([
//         getDataOfPatient(facilityId, patientId),
//         getCoverages(facilityId, patientId),
//         getContacts(facilityId, patientId),
//         getAllergyIntoleranceData(facilityId, patientId),
//         getAdvanceDirectivesConsentsData(facilityId, patientId),
//         getPractitionersData(facilityId, patientId)
//       ])
//         .then(
//           ([
//             patientRes,
//             coveragesRes,
//             contactsRes,
//             allergyRes,
//             advanceRes,
//             practionerRes
//           ]) => {
//             let allSuccessful = true;

//             if (patientRes?.data?.success) {
//               setPatietSection(patientRes.data.result);
//             } else {
//               allSuccessful = false;
//             }

//             if (coveragesRes?.data?.success) {
//               setCoverages(coveragesRes.data.result);
//             } else {
//               allSuccessful = false;
//             }

//             if (contactsRes?.data?.success) {
//               setContacts(contactsRes.data.result);
//             } else {
//               allSuccessful = false;
//             }

//             if (allergyRes?.data?.success) {
//               setAllergies(allergyRes.data.result);
//             } else {
//               allSuccessful = false;
//             }

//             if (advanceRes?.data?.success) {
//               setAdvanceConsents(advanceRes.data.result);
//             } else {
//               allSuccessful = false;
//             }

//             if (practionerRes?.data?.success) {
//               setPractitioners(practionerRes.data.result);
//             } else {
//               allSuccessful = false;
//             }

//             // Optionally handle failure case here
//             if (!allSuccessful) {
//               console.warn('One or more API responses failed.');
//             }
//           }
//         )
//         .catch(err => {
//           console.error('API error:', err);
//         })
//         .finally(() => {
//           // Always wait until Promise.all finishes completely
//           setLoadings(false);
//         });
//     }
//   }, [printInfoData]);

//   const formatTime = time => {
//     const savedTime = moment(time);
//     const now = moment(new Date());
//     const diff = now.diff(savedTime, 'hours');

//     if (diff > 12) {
//       return savedTime.format(DATE_TIME_FORMAT);
//     } else {
//       return 'Today ' + savedTime.format('HH:mm:ss');
//     }
//   };

//   function processValue(value) {
//     return value.replace(/<\/p>/g, '</p>\n').replace(/<\/?p>/g, '');
//   }
//   const getPrintData = () => {
//     setDrawerVisible(true);
//     setLoading(true);
//     getJobInfoForPrint(jobId)
//       .then(response => {
//         if (response.data.success === true) {
//           setPrintInfoData(response.data.result);
//           setLoadings(false);
//         } else {
//           notification['error']({
//             message: ' Fetch Failed',
//             description: response.data.message
//           });
//         }
//         // setDemographicsLoading(false);
//         // setRefetchDemographics(false);
//       })
//       .catch(err => {
//         // setDemographicsLoading(false);
//         // setRefetchDemographics(false);
//         console.log(err);
//         // setDemographicsLoading(false);
//       });
//   };
//   useEffect(() => {}, [patietSection]);
//   const getEditorData = () => {
//     setEditorLoading(true);
//     sectionFetch(jobId)
//       .then(response => {
//         if (response.data.success) {
//           for (let i = 0; i < response.data.result.length; i++) {
//             const resultItem = response.data.result[i];
//             for (let j = 0; j < resultItem.sections.length; j++) {
//               const section = resultItem.sections[j];
//               for (let k = 0; k < section.content.length; k++) {
//                 const contentItem = section.content[k];
//                 if (contentItem.type === 'Text') {
//                   response.data.result[i].sections[j].content[k].value =
//                     processValue(contentItem.value);
//                 }
//               }
//             }
//           }
//           setTemplate(response.data.templates && response.data.templates);

//           setSections(
//             response.data.result[0] && response.data.result[0].sections
//           );

//           setJobName(response.data.jobName);
//           setLastUpdateTime(response.data.result[0].lastUpdatedTime);
//           setEditorLoading(false);
//         } else {
//           notification['error']({
//             message: 'Section Fetch Failed',
//             description: response.data.message
//           });
//           setEditorLoading(false);
//         }
//       })
//       .catch(err => {
//         console.log(err);
//         setEditorLoading(false);
//       });
//   };

//   return loading && (editorLoading || demographicsLoading) ? (
//     <Spinner />
//   ) : (
//     <>
//       <ContainerRow>
//         <SessionDetails
//           printInfoData={printInfoData}
//           printMoreData={printMoreData?.medDiagonsis}
//           // patietSection={patietSection ? patietSection : undefined}
//           patietSection={patietSection ? patietSection : undefined}
//           coverages={coverages ? coverages : undefined}
//           contacts={contacts ? contacts : undefined}
//           allergies={allergies ? allergies : undefined}
//           advanceConsents={advanceConsents ? advanceConsents : undefined}
//           practitioners={practitioners ? practitioners : undefined}
//           loading={loadings}
//           // session={selectedSession}
//           // searchValue={searchKey === 'jobName' ? searchValue : ''}
//           setLoading={setLoading}
//           jobName={jobName}
//           ref={componentRef}
//         />
//         <div>
//           <PrintButton icon={<PrinterOutlined />} onClick={handlePrint}>
//             Print
//           </PrintButton>
//         </div>
//       </ContainerRow>
//     </>
//   );
// };

// export default FaceSheet;
